import React from "react";
import { Award, Users, MapPin, Clock } from "lucide-react";

export default function About() {
  const points = [
    { icon: Award, title: "Qualità certificata", text: "Materiali a norma e finiture eseguite a regola d'arte." },
    { icon: Users, title: "Famiglia e mestiere", text: "Una squadra di artigiani che lavora come fosse casa propria." },
    { icon: MapPin, title: "Tutta la Liguria", text: "Operiamo a Genova e in tutta la regione, costa e entroterra." },
    { icon: Clock, title: "Tempi rispettati", text: "Cronoprogramma chiaro e consegne nei tempi pattuiti." },
  ];

  return (
    <section id="chi-siamo" className="py-20 md:py-28" data-testid="about-section">
      <div className="container-page grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <span className="eyebrow">Chi siamo</span>
          <h2 className="heading-display text-3xl md:text-5xl mt-4">
            Mestiere italiano,
            <br /> spazi che durano nel tempo.
          </h2>
          <p className="text-brand-mute mt-6 leading-relaxed">
            Edil Murgia è un'impresa edile di Genova specializzata in costruzioni,
            ristrutturazioni interne ed esterne, terrazzi, tinteggiature, impiantistica
            e soluzioni chiavi in mano. Mettiamo il cliente al centro: ascoltiamo, progettiamo
            e trasformiamo idee in spazi funzionali, curati nei dettagli e su misura.
          </p>
          <p className="text-brand-mute mt-4 leading-relaxed">
            La nostra è un'edilizia consapevole, attenta al risparmio energetico e al
            valore degli immobili nel tempo: dal cappotto termico al rifacimento bagni,
            ogni intervento è seguito da chi mette la firma sulla qualità.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
          {points.map(({ icon: Icon, title, text }) => (
            <div key={title} className="card-tactile p-6" data-testid={`about-point-${title}`}>
              <div className="h-11 w-11 rounded-xl bg-brand-terracotta/10 text-brand-terracotta flex items-center justify-center">
                <Icon className="h-5 w-5" />
              </div>
              <div className="heading-display text-xl mt-4">{title}</div>
              <p className="text-brand-mute text-sm mt-2 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
